<template>
	<span class="counter"></span>
</template>

<script>
import { CountUp } from 'countup.js'

export default {
	name: 'Counter',
	props: {
		number: {
			type: Number,
			default: 0,
		},
		options: {
			type: Object,
			default: () => ({}),
		},
		doCount: false,
		immediate: {
			type: Boolean,
			default: false,
		},
	},
	data: () => ({
		count: null,
		defaultOptions: {
			duration: 3,
			useGrouping: true,
			separator: ',',
			decimal: '.',
		},
	}),
	mounted() {
		const opts = Object.assign(this.defaultOptions, this.options)
		this.count = new CountUp(this.$el, Number(this.number), opts)
		if (this.count) {
			window.addEventListener('smoothScroll', this.onScroll, { passive: true, })
		}
		if (this.immediate) {
			this.count.start()
		}
	},
	unmounted() {
		if (this.count) {
			window.removeEventListener('smoothScroll', this.onScroll)
		}
	},
	methods: {
		onScroll(evt) {
			const elBounds = this.$el.getBoundingClientRect()
			const { bottom, left, right, top, } = elBounds
			const { height, width, } = evt.detail.bounds
			if (left >= 0 && top >= 0 && bottom <= height && right <= width ) {
				if (!this.count.error) {
					this.count.start()
					window.removeEventListener('smoothScroll', this.onScroll)
				}
			}
		},
	},
	watch: {
		doCount(val) {
			if (doCount) {
				this.count.start()
			}
		}
	}
}
</script>

<style scoped lang="scss">

</style>
